import { supportContextFromLocation, supportContextLabel } from './stepmojo-support-context.js';

function applySupportContext(form) {
  const topic = form.querySelector('[data-contact-topic]');
  if (!topic) return;

  const supportType = supportContextFromLocation(window.location.search, window.location.hash);
  if (supportType === 'general-enquiry') return;

  const label = supportContextLabel(supportType);
  const option = [...topic.options].find((candidate) => candidate.value === label);
  if (option) topic.value = label;
}

document.querySelectorAll('[data-stepmojo-contact-form]').forEach(applySupportContext);
